module.exports = __webpack_public_path__ + "static/media/planificacion-8.0bebeda0.png";